import { ReactNode } from 'react';
import { cx } from 'common/utils/cx';

interface Props {
  type?: 'success' | 'error';
  children: string | ReactNode;
}

export default function ResultMessage({ children, type, ...props }: Props) {
  return (
    <p
      className={cx('form-result-message', {
        error: type === 'error',
        success: type === 'success',
      })}
      {...props}
    >
      {children}
    </p>
  );
}
